import { QSetReviewWorkflowStepCodeObject } from '@exam-management/task-management';
import { parseAsPageNumber } from '@shared/utils';
import { parseAsInteger, parseAsStringLiteral, useQueryStates } from 'nuqs';

const CODE_OPTIONS = [...Object.values(QSetReviewWorkflowStepCodeObject), 'ALL'] as const;
type QSetReviewCodeOptions = (typeof CODE_OPTIONS)[number];

export default function useQSetReviewTaskSearchParams() {
  const [{ code, page, pageSize }, setQuestionCreationTaskListSearchParams] = useQueryStates({
    code: parseAsStringLiteral(CODE_OPTIONS).withDefault('ALL'),
    page: parseAsPageNumber.withDefault(0),
    pageSize: parseAsInteger.withDefault(10),
  });

  const changePageNumber = (page: number) => {
    setQuestionCreationTaskListSearchParams({
      code,
      page,
      pageSize,
    });
  };

  const changePageSize = (pageSize: number) => {
    setQuestionCreationTaskListSearchParams({
      code,
      page: 0,
      pageSize,
    });
  };

  const changeCode = (code: QSetReviewCodeOptions) => {
    setQuestionCreationTaskListSearchParams({
      code,
      page: 0,
      pageSize,
    });
  };

  const getStatusFiltersByCode = (code: QSetReviewCodeOptions) => {
    switch (code) {
      case QSetReviewWorkflowStepCodeObject.QsetReviewTodo:
      case QSetReviewWorkflowStepCodeObject.QsetReviewInReview:
      case QSetReviewWorkflowStepCodeObject.QsetReviewReviewed:
      case QSetReviewWorkflowStepCodeObject.QsetReviewDone: {
        return [code];
      }
    }

    return null;
  };

  return [
    {
      code,
      page,
      pageSize,
    },
    {
      changeCode,
      changePageNumber,
      changePageSize,
      getStatusFiltersByCode,
    },
  ] as const;
}
